import styled from 'styled-components';
import { primaryColor, tertiaryColor } from '../../styles/variables';

const HomeContainer = styled.main`
    margin: 1rem;
    padding: 1rem;
    text-align: center;
    width: 96vw;
    height: 30vh;
    color: ${primaryColor};

    h2 {
        font-size: 1.5rem;
        margin-bottom: 1.5rem;
        margin-top: 1rem;
    }
    p {
        margin-bottom: 1.5rem;
        font-size: 1rem;
    }
    a {
        text-decoration: none;
        font-weight: bold;
        font-size: 1rem;
        color: black;
        padding: .3rem;
        background-color: ${primaryColor};
        
    }
`;

export { HomeContainer }